import * as React from "react";

function HistogramOutline(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props, {
    style: Object.assign({
      verticalAlign: '-0.125em'
    }, props.style),
    className: ['antd-mobile-icon', props.className].filter(Boolean).join(' ')
  }), /*#__PURE__*/React.createElement("g", {
    id: "HistogramOutline-HistogramOutline",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HistogramOutline-\u7F16\u7EC4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "HistogramOutline-\u77E9\u5F62",
    fill: "#FFFFFF",
    opacity: 0,
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5,13 C41.709139,13 43.5,14.790861 43.5,17 L43.5,38 C43.5,40.209139 41.709139,42 39.5,42 L36.5,42 C34.290861,42 32.5,40.209139 32.5,38 L32.5,17 C32.5,14.790861 34.290861,13 36.5,13 L39.5,13 Z M25.5,6 C27.709139,6 29.5,7.790861 29.5,10 L29.5,38 C29.5,40.209139 27.709139,42 25.5,42 L22.5,42 C20.290861,42 18.5,40.209139 18.5,38 L18.5,10 C18.5,7.790861 20.290861,6 22.5,6 L25.5,6 Z M11.5,23 C13.709139,23 15.5,24.790861 15.5,27 L15.5,38 C15.5,40.209139 13.709139,42 11.5,42 L8.5,42 C6.290861,42 4.5,40.209139 4.5,38 L4.5,27 C4.5,24.790861 6.290861,23 8.5,23 L11.5,23 Z M39.5,16 L36.5,16 C35.9871642,16 35.5644928,16.3860402 35.5067277,16.8833789 L35.5,17 L35.5,38 C35.5,38.5128358 35.8860402,38.9355072 36.3833789,38.9932723 L36.5,39 L39.5,39 C40.0128358,39 40.4355072,38.6139598 40.4932723,38.1166211 L40.5,38 L40.5,17 C40.5,16.4871642 40.1139598,16.0644928 39.6166211,16.0067277 L39.5,16 Z M25.5,9 L22.5,9 C21.9871642,9 21.5644928,9.38604019 21.5067277,9.88337887 L21.5,10 L21.5,38 C21.5,38.5128358 21.8860402,38.9355072 22.3833789,38.9932723 L22.5,39 L25.5,39 C26.0128358,39 26.4355072,38.6139598 26.4932723,38.1166211 L26.5,38 L26.5,10 C26.5,9.48716416 26.1139598,9.06449284 25.6166211,9.00672773 L25.5,9 Z M11.5,26 L8.5,26 C7.98716416,26 7.56449284,26.3860402 7.50672773,26.8833789 L7.5,27 L7.5,38 C7.5,38.5128358 7.88604019,38.9355072 8.38337887,38.9932723 L8.5,39 L11.5,39 C12.0128358,39 12.4355072,38.6139598 12.4932723,38.1166211 L12.5,38 L12.5,27 C12.5,26.4871642 12.1139598,26.0644928 11.6166211,26.0067277 L11.5,26 Z",
    id: "HistogramOutline-\u5F62\u72B6\u7ED3\u5408",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}

export default HistogramOutline;